import {useContext, useCallback} from "react"
import {CropperContext} from "../../context/CropperContext"

export const useCropperReset = () => {
    const context = useContext(CropperContext)

    if (!context) {
        throw new Error("useCropperReset must be used within CropperProvider")
    }

    const {state, dispatch} = context

    const resetAllMaterials = useCallback(() => {
        Object.keys(state.materials).forEach((index) => {
            dispatch({
                type: "RESET_MATERIAL",
                materialIndex: Number(index),
            })
        })
    }, [state.materials, dispatch])

    const resetMaterial = useCallback(
        (materialIndex: number) => {
            dispatch({
                type: "RESET_MATERIAL",
                materialIndex,
            })
        },
        [dispatch]
    )

    return {
        resetAllMaterials,
        resetMaterial,
    }
}
